module.exports = __webpack_public_path__ + "static/media/purchaseIcon.6cb03858.svg";